(function () {
  var MAX_AVATAR_BYTES = 1048576;
  var IDLE_TIMEOUT_MS = 3500;

  function bindAvatarInput() {
    var input = document.getElementById("chief_avatar");
    if (!input) return;

    var label = document.querySelector('label[for="chief_avatar"]');
    if (label) {
      label.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          e.stopPropagation();
          input.click();
        },
        true
      );
    }

    input.addEventListener("change", function () {
      var file = this.files && this.files[0];
      if (!file) return;
      if (file.size > MAX_AVATAR_BYTES) {
        alert("A foto \u00e9 muito grande. Escolha uma imagem de at\u00e9 1MB.");
        this.value = "";
        return;
      }
      var form = this.form;
      if (!form) return;
      var formData = new FormData();
      formData.append("chief[avatar]", file);
      var token = form.querySelector('input[name="authenticity_token"]');
      if (token) formData.append("authenticity_token", token.value);
      formData.append("_method", "patch");
      var action = form.getAttribute("action") || form.action;
      var csrfMeta = document.querySelector('meta[name="csrf-token"]');
      fetch(action, {
        method: "POST",
        body: formData,
        redirect: "follow",
        headers: csrfMeta ? { "X-CSRF-Token": csrfMeta.getAttribute("content") } : {}
      }).then(function (res) {
        if (res.redirected && res.url) {
          window.location.href = res.url;
        } else {
          window.location.reload();
        }
      }).catch(function () {
        form.submit();
      });
    });
  }

  function runIdle() {
    var docEl = document.getElementById("chief_document");
    if (docEl && typeof IMask !== "undefined") {
      IMask(docEl, {
        mask: [
          { mask: "000.000.000-00", maxLength: 11 },
          { mask: "00.000.000/0000-00" },
        ],
      });
    }
    var phoneEl = document.getElementById("chief_phone");
    if (phoneEl && typeof IMask !== "undefined") {
      IMask(phoneEl, { mask: "(00) 00000-0000" });
    }
    if (window.IBGE && window.IBGE.initStateCitySelect) {
      var stateEl = document.querySelector("#chief_state");
      if (stateEl) {
        window.IBGE.initStateCitySelect({
          stateSelector: "#chief_state",
          citySelector: "#chief_city",
        });
      }
    }

    var chiefForm = document.getElementById("edit_form_chief");
    if (chiefForm && typeof jQuery !== "undefined") {
      initChiefProfileValidation(chiefForm);
      return;
    }
    var adminForms = document.querySelectorAll(".needs-validation");
    if (adminForms.length && typeof jQuery !== "undefined") {
      jQuery("trix-editor").css("min-height", "150px");
      Array.prototype.slice.call(adminForms).forEach(function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    }
  }

  function initChiefProfileValidation(form) {
    var $ = window.jQuery;
    $("trix-editor").css("min-height", "100px");
    var inputs = document.querySelectorAll(".avatar_upload");
    Array.prototype.forEach.call(inputs, function (input) {
      var label = input.nextElementSibling;
      var labelVal = label ? label.innerHTML : "";
      input.addEventListener("change", function (e) {
        if (this.files && this.files[0] && this.files[0].size > MAX_AVATAR_BYTES) {
          alert("A foto \u00e9 muito grande, escolha uma menor que 1Mb.");
          this.value = "";
        }
        var fileName =
          this.files && this.files.length > 1
            ? (input.getAttribute("data-multiple-caption") || "").replace(
                "{count}",
                this.files.length
              )
            : (e.target.value.split("\\").pop() || "");
        if (label) label.innerHTML = fileName ? "Foto escolhida " + fileName : labelVal;
      });
    });

    var requiredFields = form.querySelectorAll("[required]");
    var trixEditors = form.querySelectorAll("trix-editor");

    requiredFields.forEach(function (field) {
      var isEmpty = field.type === "checkbox" ? !field.checked : !field.value;
      if (isEmpty) {
        field.classList.add("is-invalid");
        var feedback =
          field.id === "chief_terms_accepted_input"
            ? form.querySelector(".chief-terms-invalid-msg")
            : field.nextElementSibling;
        if (feedback && feedback.classList.contains("invalid-feedback")) {
          feedback.style.display = "block";
        }
      }
    });

    trixEditors.forEach(function (editor) {
      if (!editor.editor) return;
      try {
        if (!editor.editor.getDocument().toString().trim()) {
          editor.classList.add("is-invalid");
          editor.style.borderColor = "#dc3545";
        }
      } catch (e) {}
    });

    requiredFields.forEach(function (field) {
      function clearInvalid() {
        if (field.checkValidity()) {
          field.classList.remove("is-invalid");
          var feedback =
            field.id === "chief_terms_accepted_input"
              ? form.querySelector(".chief-terms-invalid-msg")
              : field.nextElementSibling;
          if (feedback && feedback.classList.contains("invalid-feedback")) {
            feedback.style.display = "none";
          }
        }
      }
      field.addEventListener("input", clearInvalid);
      field.addEventListener("change", clearInvalid);
    });

    trixEditors.forEach(function (editor) {
      editor.addEventListener("trix-change", function (e) {
        if (!e.target.editor) return;
        try {
          var value = e.target.editor.getDocument().toString().trim();
          e.target.classList.toggle("is-invalid", !value);
          e.target.style.borderColor = value ? "" : "#dc3545";
        } catch (err) {}
      });
    });

    form.addEventListener("submit", function (event) {
      var invalid = false;
      var firstInvalidField = null;

      requiredFields.forEach(function (field) {
        if (!field.checkValidity()) {
          field.classList.add("is-invalid");
          var feedback =
            field.id === "chief_terms_accepted_input"
              ? form.querySelector(".chief-terms-invalid-msg")
              : field.nextElementSibling;
          if (feedback && feedback.classList.contains("invalid-feedback")) {
            feedback.style.display = "block";
          }
          if (!invalid) firstInvalidField = field;
          invalid = true;
        }
      });

      trixEditors.forEach(function (editor) {
        if (!editor.editor) return;
        try {
          if (!editor.editor.getDocument().toString().trim()) {
            editor.classList.add("is-invalid");
            editor.style.borderColor = "#dc3545";
            if (!invalid) firstInvalidField = editor;
            invalid = true;
          }
        } catch (e) {}
      });

      var limitedSelects = form.querySelectorAll("[multiple][data-max-options]");
      limitedSelects.forEach(function (select) {
        var max = 0;
        if (select.dataset.max_options) {
          max = parseInt(select.dataset.max_options, 10);
        } else {
          var span = select.parentElement && select.parentElement.querySelector("span.text-muted");
          if (span) {
            var match = span.innerText.match(/M\u00e1ximo de (\d+)/i);
            if (match) max = parseInt(match[1], 10);
          }
        }
        var selected = $(select).val();
        if (!Array.isArray(selected)) {
          selected = typeof selected === "string" ? [selected] : [];
        }
        if (selected.length > max) {
          if (!invalid) firstInvalidField = select;
          select.classList.add("is-invalid");
          var labelEl = form.querySelector('label[for="' + select.id + '"]');
          var fieldName = labelEl && labelEl.textContent.trim()
            ? labelEl.textContent.replace(/\*/g, "").trim()
            : (select.name || select.id || "").replace(/_/g, " ");
          alert(
            "Voc\u00ea s\u00f3 pode selecionar at\u00e9 " + max + ' op\u00e7\u00f5es no campo "' + fieldName + '".'
          );
          invalid = true;
        }
      });

      if (invalid) {
        event.preventDefault();
        event.stopPropagation();
        if (
          firstInvalidField &&
          typeof firstInvalidField.scrollIntoView === "function"
        ) {
          setTimeout(function () {
            firstInvalidField.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            firstInvalidField.focus();
          }, 200);
        }
      }
      form.classList.add("was-validated");
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAvatarInput, true);
  } else {
    bindAvatarInput();
  }

  if (typeof requestIdleCallback !== "undefined") {
    requestIdleCallback(runIdle, { timeout: IDLE_TIMEOUT_MS });
  } else {
    setTimeout(runIdle, 100);
  }
})();
